import React from "react"
import Spacer from "./spacer"

const TextModule = ({ subheading, heading, description, showTopLine }) => {
  return (
    <div className={`container p40 m-p20 ml60`}>
      <div className={`${showTopLine ? "bt1" : ""}`}>
        <div className={`mt40 max-700 ma pt40`}>
          {heading && <h2 className='mb40 balance text-center'>{heading}</h2>}
          {subheading && <p className='h4 mb30 balance text-center'>{subheading}</p>}
          {description && <p className='large m0 white-space text-content nib balance' dangerouslySetInnerHTML={{ __html: description }} />}
        </div>
      </div>
      <Spacer />
    </div>
  )
}

export default TextModule
